var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_861_7127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3H3.5C3.224 3 3 3.224 3 3.5C3 3.776 3.224 4 3.5 4H9.5C9.776 4 10 3.776 10 3.5C10 3.224 9.776 3 9.5 3ZM7.5 5H3.5C3.224 5 3 5.224 3 5.5C3 5.776 3.224 6 3.5 6H7.5C7.776 6 8 5.776 8 5.5C8 5.224 7.776 5 7.5 5Z",
    fill: "#1C3A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0H2C0.897 0 0 0.897 0 2V12C0 12.194 0.112 12.371 0.288 12.453C0.354446 12.4838 0.426769 12.4998 0.5 12.5C0.615 12.5 0.729 12.46 0.82 12.384L3.681 10H11C12.103 10 13 9.103 13 8V2C13 0.897 12.103 0 11 0ZM12 8C12 8.551 11.552 9 11 9H3.5C3.383 9 3.27 9.041 3.18 9.116L1 10.933V2C1 1.449 1.448 1 2 1H11C11.552 1 12 1.449 12 2V8Z",
    fill: "#1C3A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4C13.724 4 13.5 4.224 13.5 4.5C13.5 4.776 13.724 5 14 5C14.552 5 15 5.449 15 6V14.459L13.312 13.109C13.2232 13.0386 13.1133 13.0002 13 13H6C5.448 13 5 12.551 5 12V11.5C5 11.224 4.776 11 4.5 11C4.224 11 4 11.224 4 11.5V12C4 13.103 4.897 14 6 14H12.824L15.187 15.891C15.2761 15.9615 15.3864 15.9999 15.5 16C15.573 16 15.647 15.984 15.717 15.951C15.8017 15.91 15.8732 15.8459 15.9233 15.7662C15.9733 15.6864 15.9999 15.5942 16 15.5V6C16 4.897 15.103 4 14 4Z",
    fill: "#1C3A77"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_861_7127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.1169d74147707b72a83798f2fd17eaaf.svg";
export { ForwardRef as ReactComponent };